
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'
import { BarChart } from './_elementComps/barChart'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Akupunktur half in einer Studie etwa gleich gut wie der Wirkstoff Sumatriptan,
doch die Beweislage ist dünn. Bei schweren Migräneanfällen schnitt Sumatriptan
aber besser ab. Cannabis-Präparate entspannen die Kopf- und Nackenmuskeln,
helfen beim Schlafen und bessern die Migräne bei manchen Personen – auch da ist
die Beweislage aber noch dünn. Achtsamkeitstraining und Hypnose können ebenfalls
einen Versuch wert sein.`}</p>
    <p>{`Reto Agosti, Chefarzt des Kopfwehzentrums Hirslanden in Zollikon und Zürich,
empfiehlt unter anderem eine Craniosakraltherapie bei «Therapeuten, die bei
Migräne versiert sind». Yoga dagegen ist seiner Erfahrung nach bei manchen
Betroffenen «zu heftig». Für die meisten alternativen Methoden gibt es keinen
wissenschaftlichen Beweis, dass sie wirken. Weder Aufbissschienen noch
Chiropraktik, Darmsanierung und anderes mehr haben ihren Nutzen bei
Kopfschmerzen oder Migräne unter Beweis gestellt.`}</p>
    <BarChart data={[['Progressive Muskelrelaxation', 41], ['Finger-Biofeedback', 30], ['Biofeedback', 51], ['kognitive Verhaltenstherapie', 39], ['Placebo-Gabe', 9], ['keine Behandlung', 5], ['Vorbeugung mit der Betablocker Propranolol', 44]].sort((a, b) => {
      return b[1] - a[1];
    })} title='Diese Therapien helfen am besten' chartKey='Verbesserung der Migräne in Prozent' mdxType="BarChart" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;